module.exports = __webpack_public_path__ + "img/icon-income-blue.5d262bac.svg";